import React from 'react';
import PropTypes from 'prop-types';
import {
  Tabs,
  TabList,
  Tab as ReachTab,
  TabPanels,
  TabPanel
} from '@reach/tabs';

import './_reach.module.scss';
import styles from './styles.module.scss';

function Tab(props) {
  const classNames = [
    styles.tab,
    props.isSelected ? styles.tabSelected : '',
    props.className
  ].join(' ');

  return (
    <ReachTab {...props} className={classNames}>
      {props.children}
    </ReachTab>
  );
}

Tab.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
  isSelected: PropTypes.bool
};

Tab.defaultProps = {
  className: null,
  isSelected: false
};

// Exports our custom Tabs component along with the default reach-ui tab and panel components.
export { Tabs, TabList, Tab, TabPanels, TabPanel };

export default Tabs;
